import React from "react";
import Router from "./router";
import { PrimeReactProvider } from "primereact/api";
import { merchantPortalPT } from "./config/primereact-pt";
import ThemeProvider from "./components/ThemeProvider";

export default class MainComponentWrapper extends React.Component {
    render() {
        return (
            <ThemeProvider>
                <PrimeReactProvider value={{ unstyled: true, pt: merchantPortalPT }}>
                    <div className="min-h-screen font-sans bg-body text-neutral-900 dark:bg-neutral-950 dark:text-neutral-100 transition-colors duration-200">
                        <Router />
                    </div>
                </PrimeReactProvider>
            </ThemeProvider>
        );
    }
}
